<template>
  <div class="CIT_background">
    <div
      v-if="loading"
      class="d-flex vertical-center justify-content-center align-items-center"
      style="height: 85vh; dislay: flex"
    >
      <LoadingMDL />
    </div>

    <div class="position" v-else>
      <div class="container_CIT02" style="display: flex; flex-direction: row">
        <div v-if="pageWidth > 1024" class="btnPrev">
          <div class="btn-prev" v-if="canPrev">
            <ButtonIcon :iconUrl="prev_icon" :size="1" @click="onPrev()" />
          </div>
        </div>
        <div class="block">
          <vue-dropdown
            @setSelectedOption="topicSetter($event)"
            :config="config"
            class="dropdown_Style"
          ></vue-dropdown>
          <Card class="card" :imgUrl="content[index]" />
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="btn-exit">
            <ButtonIcon
              :bgColor="`#ed8e91`"
              :iconUrl="close_icon"
              :size="1"
              @click="onClose()"
            />
          </div>
          <div v-if="pageWidth > 1024">
            <div class="btn-prev-right" v-if="canNext">
              <ButtonIcon :iconUrl="next_icon" :size="1" @click="onNext()" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="pageWidth <= 1024" class="btn-close-container">
      <div class="buttonBack" :style="isButtonAvaliable()" @click="onPrev()">
        PREVIOUS
      </div>
      <div
        class="buttonBack"
        :style="isMobileNextButtonAvaliable()"
        @click="onNext()"
      >
        NEXT
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../../components/signInCss/Button.vue";
import Card from "@/components/elements/Card.vue";
import ButtonIcon from "@/components/elements/Buttons/ButtonIcon.vue";
import { mapGetters } from "vuex";
import LoadingMDL from "@/components/loading/LoadingMDL";
import "../../assets/scss/chinessStyle2.scss";
import VueDropdown from "vue-dynamic-dropdown";

export default {
  components: { Button, Card, ButtonIcon, LoadingMDL, VueDropdown },
  name: "CLP01",
  props: {},
  data() {
    return {
      prev_icon: "/icons/arrow-left.svg",
      close_icon: "/icons/close.svg",
      next_icon: "/icons/arrow-right.svg",
      index: 0,
      baseUrl: process.env.VUE_APP_URL_SOUND,
      canPrev: false,
      canNext: true,
      loading: true,
      content: [],
      pageWidth: window.innerWidth,
      config: {
        options: [],
        placeholder: "Lesson 1",
        backgroundColor: "aquamarine",
      },
      tmpContent: [],
      code:"",
      section:""
    };
  },
  methods: {
    onPrev: function () {
      if (this.index != 0) {
        this.index -= 1;
        if (this.index == 0) {
          this.canPrev = false;
          this.canNext = true;
        } else {
          this.canPrev = true;
          this.canNext = true;
        }
      } else {
        this.canPrev = false;
      }
    },
    onNext: function () {
      if (this.canNext) {
        this.index += 1;
        let length = this.content.length - 1;
        if (this.index < length) {
          if (length == this.index) {
            this.canPrev = true;
            this.canNext = false;
          } else {
            this.canPrev = true;
            this.canNext = true;
          }
        } else {
          this.canNext = false;
        }
      }
    },
    onClose: function () {
      this.$router.push("/LS01/1");
    },
    isButtonAvaliable: function () {
      if (this.canPrev) {
        return "background-color: #ed8e91";
      } else {
        return "background-color: #D3D3D3";
      }
    },
    isMobileNextButtonAvaliable: function () {
      if (!this.canNext) {
        return "background-color: #D3D3D3";
      } else {
        return "background-color: #1e5bd7";
      }
    },
    topicSetter: function (event) {
      this.config.placeholder = event.value;
      let topicNumber = event.value.split(" ");
      this.index = 0;
      this.content = [];
      this.tmpContent[topicNumber[1] - 1].topics.forEach((element) => {
        this.content.push(this.baseUrl + "" + element.url);
      });
    },
  },

  computed: {
    ...mapGetters({
      getSheetResultData: "template/getSheetResultData",
    }),
  },
  watch: {
    getSheetResultData: async function (value) {
      this.tmpContent = value.data;
      for (let i = 0; i < value.data.length; i++) {
        this.config.options.push({ value: "Lesson " + (i + 1) });
      }
      let store = [];
      if (value.data.length > 0) {
        value.data[0].topics.forEach((element) => {
          if (element.data == undefined) {
            store.push(this.baseUrl + "" + element.url);
          } else {
            store.push(this.baseUrl + "" + element.data.url);
          }
        });
      } else {
        store.push(
          "https://cdn11.bigcommerce.com/s-480u37mgay/images/stencil/1280x1280/products/70478/50469/MCPG529_19__12975.1475006562.jpg?c=2"
        );
        this.canNext = false;
      }
      this.content = store;
      this.loading = false;
    },
  },
  created() {
    console.log("width : ", window.innerWidth, "height : ", window.innerHeight);
    this.currentRoute = this.$route.name + "-" + this.$route.params.id;
    this.courseData = this.$store.getters["necessary/getLerningCourse"]
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection']
    console.log(this.section);
  },
  mounted() {
    let payload = {
      // code: "605418cb883ae722ba1b0c5f",
      code:this.code,
      templateCode: "CLP01-1",
      section:this.section
      // section: "testing",
    };
    this.$store.dispatch("template/fetchSheetResultChinese2", payload);
  },
  beforeDestroy() {
    // used for update value before close this page
    // สมมติว่าจับเวลาใช้ในหน้านี้กี่นาที ให้มาเก็บในนี้
  },
};
</script>

<style scoped lang="scss">
.dropdown_Style {
  position: absolute;
  z-index: 1000;
  top: 10%;
}
.btnPrev {
  display: flex;
  margin-top: 310px;
}
.CIT_background {
  background-color: #ffdc77;
}
.position {
  display: flex;
  align-content: center;
  justify-content: center;
  padding-bottom: 5%;
}
.block {
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1440px;
  height: 760px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 20px; /* 5px rounded corners */
  background-color: aquamarine;
}
.buttonBack {
  outline: none;
  border: none;
  width: 100%;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 10px;
  font-size: 16px;
  color: white;
  margin: 20px;
  background-color: #89abe6;
}
.btn-close-container {
  display: flex;
  text-align: center;
  padding-bottom: 42%;
}
.card {
  width: 1390px;
  height: 720px;
  display: flex;
  justify-content: center;
  background-color: white;
  border-radius: 20px; /* 5px rounded corners */
  margin: 0;
}
.btn-exit {
  width: 60px;
  height: 60px;
  border-radius: 8px !important;
  border-color: #ed8e91;
  background-color: #ed8e91;
  cursor: pointer;
  margin-left: 30%;
}
.container_CIT02 {
  margin-left: auto;
  margin-right: auto;
  padding-top: 5%;
}
.btn-prev {
  width: 70px;
  height: 150px;
  margin-top: 20%;
  cursor: pointer;
  border-radius: 12px 0px 0px 12px;
  background-color: #1e5bd7;
}
.btn-prev-right {
  width: 70px;
  height: 150px;
  cursor: pointer;
  border-radius: 0px 12px 12px 0px;
  background-color: #1e5bd7;
  margin-top: 256px;
}

// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .dropdown_Style {
    top: 14%;
  }
  .position {
    padding-top: 45%;
    padding-bottom: 6%;
  }
  .block {
    width: auto;
    height: auto;
  }
  .card {
    width: 340px;
    height: 300px;
  }
  .btn-prev {
    width: 40px;
    height: 100px;
    margin-top: 20%;
  }
  .btn-prev-right {
    width: 40px;
    height: 100px;
    margin-top: 65%;
  }
  .btn-exit {
    position: absolute;
    width: 40px;
    height: 40px;
    right: 3%;
    top: 23%;
  }
  .buttonBack {
    outline: none;
    border: none;
    width: 100%;
    text-align: center;
    padding-top: 12px;
    padding-bottom: 12px;
    border-radius: 10px;
    font-size: 16px;
    color: white;
    margin: 20px;
    background-color: #89abe6;
  }
  .btn-close-container {
    display: flex;
    text-align: center;
    padding-bottom: 42%;
  }
}
// resolution ipad
@media only screen and (min-width: 700px) and (max-width: 821px) {
  .position {
    padding-top: 25%;
    padding-bottom: 3%;
  }
  .dropdown_Style {
    top: 15%;
  }
  .block {
    width: 700px;
    height: 420px;
  }
  .card {
    width: 650px;
    height: 370px;
  }
  .btn-prev {
    width: 50px;
    height: 120px;
    margin-top: 15%;
  }
  .btn-prev-right {
    width: 50px;
    height: 120px;
    margin-top: 55px;
  }
  .btn-exit {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 3%;
    top: 25%;
  }
  .buttonBack {
    padding-top: 12px;
    padding-bottom: 12px;
    border-radius: 10px;
    font-size: 16px;
    color: white;
    margin: 30px;
    margin-left: 65px;
    margin-right: 65px;
  }
  .btn-close-container {
    padding-bottom: 24%;
  }
}
// resolution ipad pro
@media only screen and (min-width: 1024px) and (max-width: 1367px) {
  .dropdown_Style {
    top: 9.5%;
  }
  .container_CIT02 {
    padding-top: 4%;
  }
  .btnPrev {
    display: flex;
    margin-top: 12px;
  }
  .position {
    padding-top: 8%;
    padding-bottom: 0%;
  }
  .block {
    width: 900px;
    height: 550px;
  }
  .card {
    width: 850px;
    height: 500px;
  }
  .btn-prev {
    width: 50px;
    height: 120px;
    margin-top: 200px;
  }
  .btn-prev-right {
    width: 50px;
    height: 120px;
    margin-top: 195px;
  }
  .btn-exit {
    position: absolute;
    width: 50px;
    height: 50px;
    right: 3%;
    top: 20%;
  }
  .buttonBack {
    padding-top: 12px;
    padding-bottom: 12px;
    border-radius: 10px;
    font-size: 16px;
    color: white;
    margin: 30px;
    margin-left: 120px;
    margin-right: 120px;
  }
  .btn-close-container {
    padding-bottom: 24%;
  }
}
// PC MAX 1400
@media only screen and (min-width: 1367px) and (max-width: 1400px) {
  .container_CIT02 {
    margin-top: 10%;
  }
  .block {
    width: 600px;
    height: 350px;
  }
  .card {
    width: 550px;
    height: 300px;
  }
  .btn-prev {
    width: 50px;
    height: 120px;
    margin-top: 15%;
  }
  .btn-prev-right {
    width: 50px;
    height: 120px;
    margin-top: 55px;
  }
  .btn-exit {
    width: 50px;
    height: 50px;
    margin-left: 15%;
  }
  .btn-close-container {
    padding-bottom: 10%;
  }
}
@media only screen and (min-width: 1400px) and (max-width: 1600px) {
  .container_CIT02 {
    margin-top: 3.5%;
  }
  .block {
    width: 1250px;
    height: 600px;
  }
  .card {
    width: 1200px;
    height: 550px;
  }
  .btn-prev {
    width: 50px;
    height: 120px;
    margin-top: 15%;
  }
  .btn-prev-right {
    width: 50px;
    height: 120px;
    margin-top: 200px;
  }
  .btn-exit {
    width: 50px;
    height: 50px;
    margin-left: 15%;
  }
  .btnPrev {
    display: flex;
    margin-top: 250px;
  }
}
</style>
